<template>
  <scroll-table>
    <template v-if="isLoading">
      <template v-if="!isInit || !isError">
        <loading :message="'データ読み込み中...'"></loading>
      </template>
    </template>
    <template v-else>
      <!-- 検索結果を一覧表示 -->
      <table v-if="dataList" class="list-table">
        <thead>
          <tr>
            <!-- <th class="id">申請ID</th> -->
            <th class="detail-link"></th>

            <!-- MEDICA_AS-1235対応 -->
            <template
              v-if="authStore.hasPermission(PermissionConst.SHINSEI_SEARCH_SYOUNIN) || authStore.hasPermission(PermissionConst.SHINSEI_SEARCH_SYOZOKU) || authStore.hasPermission(PermissionConst.SHINSEI_SEARCH_ALL)">
              <th class="type">社員番号</th>
            </template>

            <th class="name">氏名</th>
            <th class="type">申請種別</th>
            <th class="status">承認種別</th>
            <th class="place">就業場所</th>
            <th class="date">取得日</th>
            <th class="comment">コメント</th>
          </tr>
        </thead>
        <tbody>
          <tr :key="index" v-for="(item, index) in dataList">
            <!-- <td class="align-center">{{ item.shinsei_id }}</td> -->
            <td class="align-center">
              <p><button class="btn btn-detail" v-on:click="clickBtnDetail(item)">詳細</button></p>
            </td>

            <!-- MEDICA_AS-1235対応 -->
            <template
              v-if="authStore.hasPermission(PermissionConst.SHINSEI_SEARCH_SYOUNIN) || authStore.hasPermission(PermissionConst.SHINSEI_SEARCH_SYOZOKU) || authStore.hasPermission(PermissionConst.SHINSEI_SEARCH_ALL)">
              <td class="align-center">{{ item.staff_code }}</td>
            </template>

            <td>{{ item.staff_name }}</td>
            <td class="align-center">{{ item.shinsei_type_label }}</td>
            <td class="align-center">{{ item.kekka_type_str }}</td>
            <td>{{ item.syuugyou_basyo_name }}</td>
            <td class="pre">{{ item.targetDateStr }}</td>
            <td><span
                v-if="item.shinsei_type === OptionConst.SHINSEI_CODE.IDOU && item.isHannichiHosei"
                class="color-red">【半日補正】 </span>{{ item.syounin_status_notes }}</td>
          </tr>
        </tbody>
      </table>
    </template>
  </scroll-table>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { dateFormat } from "@/filters/common";
import { RouterConst } from "@/const/Router";
import { ShinseiList } from "@/types/Shinsei";
import OptionConst from "@/const/Option";
import { useAuthStore } from "@/store/auth";
import { PermissionConst } from "@/const/Permission";
import { DialogService } from "@/service/DialogService";
import { HayabanOsobanService } from "@/service/HayabanOsobanService";
import { KoukyuuService } from "@/service/KoukyuuService";
import { useRouter } from 'vue-router';

export default defineComponent({
  props: {
    dataList: {
      type: Object as () => ShinseiList[],
      default: null
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    isError: {
      type: Boolean,
      default: false
    },
    isInit: {
      type: Boolean,
      default: false
    },
  },
  setup() {

    const router = useRouter()
    const authStore = useAuthStore()
    const hayabanOsobanService = new HayabanOsobanService()
    const koukyuuService = new KoukyuuService()

    const clickBtnDetail = async (data: ShinseiList) => {
      if (!data.shinsei_id) {
        return
      }

      if (!data.isNoApproval) {
        // 承認が必要な申請の場合は詳細画面へ遷移
        router.push({
            name: RouterConst.SHINSEI_DETAIL, params: { id: data.shinsei_id }
        })
        return
      }

      const dialogResult = await DialogService.open({
        imageUrl: '/img/no_approval_desc.png',
        text: 'タイムシートへ遷移しますか？',
        showCancelButton: true,
        confirmButtonText: '遷移します',
        cancelButtonText: 'キャンセル',
      }, true)
      if (!dialogResult.isConfirmed) {
        return
      }

      let detail = null
      if (data.hayaban_osoban_id == data.shinsei_id) {
        // 早番遅番申請の場合
        detail = await hayabanOsobanService.getDetail(data.hayaban_osoban_id)
      } else if (data.koukyuu_id == data.shinsei_id) {
        // 公休申請の場合
        detail = await koukyuuService.getDetail(data.koukyuu_id)
      }

      if (detail !== null) {
        router.push({
          name: RouterConst.KINMU_LIST, query: {
            from: RouterConst.SHINSEI_LIST,
            targetUserId: data.user_id,
            mst_syuugyou_basyo_id: detail.mst_syuugyou_basyo_id,
            koyou_keiyaku_id: detail.koyou_keiyaku_id,
            year: detail.kinmu_year,
            month: detail.kinmu_month
          }
        })
      }
    };

    return {
      dateFormat,
      RouterConst,
      OptionConst,
      authStore,
      PermissionConst,
      clickBtnDetail,
    };
  },
  components: {},
});
</script>

<style lang="scss" scoped>
@import '@scss/components/shinsei-list.scss';
</style>
